import { render, staticRenderFns } from "./LandingPageBestMusic.vue?vue&type=template&id=c023debc"
import script from "./LandingPageBestMusic.vue?vue&type=script&lang=js"
export * from "./LandingPageBestMusic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports